module.exports = __webpack_public_path__ + "img/st.20bd7585.png";